module.exports = __webpack_public_path__ + "static/media/galerija_2019 (3).887492eb.jpg";